import EditTask from './editTaskContainer';

export default EditTask;
